<template>
  <AdminConfirmModal
    v-model="getDeleteAssistantModal"
    :message="$t('Tariffs.sure_want_delete_employee')"
    :confirm-text="$t('Default.accept')"
    @confirm="deleteAssistant"
  />
</template>
<script>
import { GlobalMutationTypes } from "@/store/modules/global/types";
import { DispatchTypes } from "@/store/modules/admin/assistant/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentAssistant"],
  setup(props) {
    const store = useStore();

    const getDeleteAssistantModal = shortComputed(
      {
        storeType: "global",
        key: "getDeleteAssistantModal",
      },
      GlobalMutationTypes.setDeleteAssistantModal
    );

    const deleteAssistant = () => {
      store
        .dispatch(
          DispatchTypes.deleteAssistant,
          props.currentAssistant.id + "/"
        )
        .then(() => {
          store.commit(GlobalMutationTypes.setDeleteAssistantModal, false);
        });
    };

    return {
      store,
      getDeleteAssistantModal,
      deleteAssistant,
    };
  },
};
</script>
